export default __webpack_public_path__ + "static/media/50_mobile.1045461f.jpg";